class ConstantAlertMessages {
    static CUSTOMER_LOCATION_NOT_FOUND = "Müşteri konum bilgisi bulunamadı."
    static TOW_TRUCK_LOCATION_NOT_FOUND = "Çekici konum bilgisi bulunamadı."
}
export default ConstantAlertMessages